export default "__VITE_ASSET__DUb2Ge9t__"